import type { Provider } from '../model'

export const PROVIDER_BADGE_LABEL_MAP: Record<Provider.Id, string> = {
  ['orca']: 'ORCA',
  ['jupiter']: 'JUP',
  ['meteora-dyn']: 'DYN',
  ['meteora-dlmm']: 'DLMM',
  ['raydium-v4']: 'RAY V4',
  ['raydium-cpmm']: 'CPMM',
  ['raydium-clmm']: 'CLMM',
  ['raydium-launchpad']: 'RAY L.',
  ['bonk-fun']: 'BFun',
  ['uniswap-v2']: 'V2',
  ['uniswap-v3']: 'V3',
  ['dedust']: 'DEDUST',
  ['pump-fun']: 'PF',
  ['pump-swap']: 'PS',
  ['stonfi-v1']: 'STONFI',
  ['stonfi-v2']: 'STONFI',
  ['deluge-vlmm']: 'VLMM',
  ['pancakeswap-v1']: 'Pancake V1',
  ['pancakeswap-v2']: 'Pancake V2',
  ['pancakeswap-v3']: 'Pancake V3',
}
